import React from "react";

const AudienceInf = () => {
  return (
    <>
      {" "}
      <div className="tab-content-section">
        <div className="d-flex justify-content-center mb-4">
          <div className="btn-group">
            <button
              className="btn btn-danger audience-tab active"
              data-type="followers"
            >
              FOLLOWERS
            </button>
            <button
              className="btn btn-outline-secondary audience-tab"
              data-type="engagers"
            >
              ENGAGERS
            </button>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-4 border rounded text-center">
              <h2 className="text-success" id="credibilityValue">
                79.26%
              </h2>
              <p className="mb-0">
                Followers' Credibility <i className="ri-question-line"></i>
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded text-center">
              <h2 className="text-danger" id="notableValue">
                7.11%
              </h2>
              <p className="mb-0">
                Notable Followers <i className="ri-question-line"></i>
              </p>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-6">
            <div className="p-4 border rounded">
              <div className="d-flex justify-content-between mb-3">
                <h5>Audience Type</h5>
                <a href="#">
                  <i className="ri-question-line"></i>
                </a>
              </div>

              <div className="mb-3 small">
                <span className="me-3">🟠 Mass followers: 13.77%</span>
                <span className="me-3">🔴 Suspicious: 15.30%</span>
                <br />
                <span className="me-3">🟢 Influencers: 3.15%</span>
                <span>🟢 Real: 67.78%</span>
              </div>

              <div id="audienceDonut" style={{ height: "250px" }}></div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded">
              <div className="d-flex justify-content-between mb-3">
                <h5>Location</h5>
                <a href="#">
                  <i className="ri-question-line"></i>
                </a>
              </div>

              <div className="d-flex gap-4 mb-3" id="locationTabs">
                <span
                  className="location-tab active text-danger border-bottom border-danger pb-1"
                  data-type="country"
                >
                  COUNTRY
                </span>
                <span className="location-tab text-muted" data-type="state">
                  STATE
                </span>
                <span className="location-tab text-muted" data-type="city">
                  CITY
                </span>
              </div>

              <div id="locationChart" style={{ height: "250px" }}></div>
              <a
                href="#"
                className="text-end text-danger fw-semibold d-block mt-2"
                data-bs-toggle="modal"
                data-bs-target="#locationModal"
              >
                VIEW MORE
              </a>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-6">
            <div className="p-4 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Audience Reachability</h5>
                <a href="#">
                  <i className="ri-question-line"></i>
                </a>
              </div>
              <div id="reachabilityChart" style={{ height: "250px" }}></div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Notable Followers</h5>
                <a href="#">
                  <i className="ri-question-line"></i>
                </a>
              </div>

              <div className="d-flex align-items-center mb-3">
                <img
                  src="../assets/images/users/avatar-2.jpg"
                  className="rounded-circle me-3"
                  width="45"
                />
                <div>
                  <h6 className="mb-0">Raj Shamani</h6>
                  <small className="text-muted">
                    5.76M followers, 60.82K engagements
                  </small>
                </div>
              </div>

              <div className="d-flex align-items-center mb-3">
                <img
                  src="../assets/images/users/avatar-3.jpg"
                  className="rounded-circle me-3"
                  width="45"
                />
                <div>
                  <h6 className="mb-0">Abhishek Kar</h6>
                  <small className="text-muted">
                    3.39M followers, 61.67K engagements
                  </small>
                </div>
              </div>

              <div className="d-flex align-items-center mb-3">
                <img
                  src="../assets/images/users/avatar-4.jpg"
                  className="rounded-circle me-3"
                  width="45"
                />
                <div>
                  <h6 className="mb-0">Neha Nagar</h6>
                  <small className="text-muted">
                    2.16M followers, 12.56K engagements
                  </small>
                </div>
              </div>

              <a
                href="#"
                className="text-end text-danger fw-semibold d-block mt-2"
                data-bs-toggle="modal"
                data-bs-target="#notableModal"
              >
                VIEW MORE
              </a>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-6">
            <div className="p-4 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Audience Brand Affinity</h5>
                <a href="#">
                  <i className="ri-question-line"></i>
                </a>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <span>Apple</span>
                  <span>10.42%</span>
                </div>
                <div className="progress mt-1">
                  <div
                    className="progress-bar"
                    style={{ width: "10.42%" }}
                  ></div>
                </div>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <span>Travelgram</span>
                  <span>8.86%</span>
                </div>
                <div className="progress mt-1">
                  <div
                    className="progress-bar"
                    style={{ width: "8.86%" }}
                  ></div>
                </div>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <span>FOREX</span>
                  <span>4.66%</span>
                </div>
                <div className="progress mt-1">
                  <div
                    className="progress-bar"
                    style={{ width: "4.66%" }}
                  ></div>
                </div>
              </div>

              <a href="#" className="text-end text-danger fw-semibold d-block">
                VIEW MORE
              </a>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Audience Interests</h5>
                <a href="#">
                  <i className="ri-question-line"></i>
                </a>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <span>Camera & Photography</span>
                  <span>44.69%</span>
                </div>
                <div className="progress mt-1">
                  <div
                    className="progress-bar"
                    style={{ width: "44.69%" }}
                  ></div>
                </div>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <span>Friends & Family</span>
                  <span>43.75%</span>
                </div>
                <div className="progress mt-1">
                  <div
                    className="progress-bar"
                    style={{ width: "43.75%" }}
                  ></div>
                </div>
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between">
                  <span>Travel</span>
                  <span>38.24%</span>
                </div>
                <div className="progress mt-1">
                  <div
                    className="progress-bar"
                    style={{ width: "38.24%" }}
                  ></div>
                </div>
              </div>

              <a href="#" className="text-end text-danger fw-semibold d-block">
                VIEW MORE
              </a>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-6">
            <div className="p-4 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Age Distribution</h5>
                <a href="#">
                  <i className="ri-question-line"></i>
                </a>
              </div>
              <div id="ageDistributionChart" style={{ height: "300px" }}></div>
              <a
                href="#"
                className="text-end text-danger fw-semibold d-block mt-2"
              >
                VIEW MORE
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AudienceInf;
